import {
    addBeforeApplyPromotionsEvent,
    changeMode,
    getProductsWithMemberPrice,
    removeOnePromotionPromoCode,
    setCustomer,
    setOnePromotionPromoCode,
    showDialogue,
    updateProduct
} from "../../redux/actions";
import {APPLY_PROMOTIONS, REMOVE_CUSTOMER, SET_CUSTOMER} from "../../redux/actionTypes";
import {getCurrentLoyaltyCustomer, getProductsInBasket, getReasonCodeByNameAndPurpose} from "../../redux/selectors";
import moment from "moment/moment";
import {fetchWithTimeout} from "../../util/helperFunctions";
import Decimal from "decimal.js";
import {reassignCustomer} from "../../redux/dto/customer";
import {APP_MODE_BEFORE_PAYMENT, DECATHLON_EMPLOYEE_DISCOUNT_PRODUCT_SERIES} from "../../redux/appConstants";

/**
 * One Promotion
 * Integrates Decathlon promotion API
 */
const OP = {
    conf: false,
    setConf: (erplyConfig) => {
        let excludedCategories = [];
        if(typeof window?.AppConf.onePromotionExcludedCategories !== "undefined"){
            excludedCategories = window?.AppConf.onePromotionExcludedCategories.split(",");
        }

        let reasonCodeMap = {
            'SET': 'DKT:Set',
            'BUNDLE': 'DKT:Bundle',
            'COUPON': 'DKT:Coupon'
        }
        if(typeof window?.AppConf?.onePromotionReasonCodes !== "undefined"){
            reasonCodeMap = window.AppConf.onePromotionReasonCodes;
        }

        let quoteTimeout = window.AppConf?.onePromotionQuoteTimeout ?? 4;
        if(quoteTimeout === ""){
            quoteTimeout = 4;
        }

        OP.conf = {
            getQuoteTimeout: quoteTimeout * 1000,
            couponEnabled: window.AppConf?.onePromotionCouponEnabled ?? false,
            auth: erplyConfig.DKT_PROXY_AUTH,
            clientName: erplyConfig.DKT_ONEPAY_CLIENT_NAME,
            currency: erplyConfig.default_currency,
            timezone: erplyConfig.timezone,
            reasonCodeMap,
            excludedCategories
        }
    },
    Item: function (code, quantity, price, total, rowNumber, priceType){
        this.code = code;
        this.quantity = parseFloat(quantity);
        this.price = price;
        this.total = total;
        this.rowNumber = rowNumber;
        this.priceType = priceType;
    },
    addPromotion: (store, retrigger, promoCodeSet = false, preview=false) => {
        console.log("OP: addPromotion", {retrigger, promoCodeSet});
        return new Promise((resolve, reject) => {
            let state = store.getState();
            let productsInBasket = getProductsInBasket(state);
            let reasonCodes = state.rootReducer.reasonCodes;
            let referenceNumber = state.rootReducer.warehouse.code;
            let customer = reassignCustomer(state.rootReducer.customer);
            let dispatch = store.dispatch;
            let promoCode = state.rootReducer.onePromotionPromoCode === false ? false : state.rootReducer.onePromotionPromoCode.code;
            let includeAll = promoCode !== false;
            let {items, products, previouslyPromotionableProducts} = OP.getPromotionableProducts(productsInBasket, includeAll, customer);
            let itemsTotalQuantity = items.reduce((acc, el) => {
                acc += el.quantity;
                return acc;
            },0);

            console.log("OP: addPromotion", {
                productsInBasket, reasonCodes, referenceNumber, customer, promoCode, items,
                products, previouslyPromotionableProducts, itemsTotalQuantity,
                previousMixMatchProductsQuantity: OP.previousMixMatchProductsQuantity
            });

            if( items.length === 0 ||
                ( !includeAll && items.length === 1 && items[0].quantity === 1 && OP.previousMixMatchProductsQuantity === 0 ) ||
                ( OP.previousMixMatchProductsQuantity === itemsTotalQuantity && !retrigger)
            ){
                if(items.length === 0) {
                    OP.removeOnePromotionFromAllProducts(productsInBasket, preview, dispatch);
                    if(promoCode !== false){
                        store.dispatch(setOnePromotionPromoCode(promoCode, "error", "COUPON_NOT_APPLICABLE"));
                    }
                    OP.previousMixMatchProductsQuantity = 0;
                }
                resolve(productsInBasket);
                return;
            }
            OP.removeOnePromotionFromAllProducts(previouslyPromotionableProducts, preview, dispatch);
            OP.previousMixMatchProductsQuantity = itemsTotalQuantity;

            let member = preview !== false ? preview.customer : getCurrentLoyaltyCustomer(state);

            store.dispatch(getProductsWithMemberPrice(products, state.rootReducer.pos, member, (productsWithMemberPrice) => {
                let productIDsWithMemberPrice = productsWithMemberPrice.reduce((acc, el) => {
                    acc.push(parseInt(el.productID));
                    return acc;
                }, []);
                console.log("OP:", {productIDsWithMemberPrice, productsWithMemberPrice});
                items = OP.filterExcludedItems(items, products, customer, productIDsWithMemberPrice);
                console.log("OP: getQuote", {items});
                OP.getQuote(items, referenceNumber, promoCode, customer).then(quote => {
                    products.forEach((product, index) => {
                        const hasPromotion = (promotionProduct) => {
                            return typeof promotionProduct?.total_promotion?.applied_promotions !== "undefined" && promotionProduct.total_promotion.applied_promotions.length > 0
                        }

                        let promotionProduct = quote.items.filter(item => parseInt(item.original_basket_line_id) === product.lineNumber).reduce((acc, el) => {
                            if(Object.keys(acc).length === 0){
                                acc = el;
                            }else{
                                acc.quantity += el.quantity;
                                acc.total_price.value += el.total_price.value
                                if(hasPromotion(el)){
                                    acc.total_promotion.applied_promotions = el.total_promotion.applied_promotions;
                                }
                            }
                            return acc;
                        }, false);
                        if(promotionProduct !== false){
                            promotionProduct.unit_price.value = promotionProduct.total_price.value / promotionProduct.quantity;
                        }

                        if(promotionProduct !== false && hasPromotion(promotionProduct)){
                            let originalPrice = new Decimal(product.originalPriceWithVAT || product.vatPrice);
                            product.onePromotion = {
                                discount: originalPrice.minus(new Decimal(promotionProduct.unit_price.value)).dividedBy(originalPrice).times(100).toDecimalPlaces(4).toNumber(),
                                priceDerivationRuleID: promotionProduct.total_promotion.applied_promotions[0].promotion_id
                            }
                            //product.setManualDiscountUnitPrice(promotionProduct.unit_price.value, false);
                            let reasonCode = OP.conf.reasonCodeMap[promotionProduct.total_promotion.applied_promotions[0]?.promotion_type] ?? false;
                            if(reasonCode !== false){
                                let reason = getReasonCodeByNameAndPurpose(reasonCodes, reasonCode, "DISCOUNT");
                                if(typeof reason !== "undefined"){
                                    product.onePromotion.reasonCode = reason;
                                }
                            }
                            if(preview === false){
                                dispatch(updateProduct(product, true));
                            }
                        }else{
                            OP.removeOnePromotionFromProduct(product, preview, dispatch);
                        }
                    });
                    if(promoCode !== false){
                        let appliedPromoCode = (quote?.promotions ?? []).find(el => {
                            return el.promotion_name.toUpperCase() === promoCode.toUpperCase() ||
                                el.promotion_name.toUpperCase() === promoCode.toUpperCase().replace(/\s+/g, '')
                        });
                        if(typeof appliedPromoCode === "undefined"){
                            let notAppliedPromoCode = (quote?.not_applied_promotions ?? []).find(el => {
                                if(typeof el.coupon_code !== "undefined"){
                                    return el.coupon_code.toUpperCase() === promoCode.toUpperCase();
                                }
                                return false;
                            });
                            if(typeof notAppliedPromoCode !== "undefined"){
                                if(state.rootReducer.onePromotionPromoCode.message !== notAppliedPromoCode.error_code){
                                    let errors = quote.not_applied_promotions.filter(el => {
                                        if(typeof el.coupon_code !== "undefined"){
                                            return el.coupon_code.toUpperCase() === promoCode.toUpperCase();
                                        }
                                        return false;
                                    });
                                    dispatch(setOnePromotionPromoCode(promoCode, "error", notAppliedPromoCode.error_code, errors));
                                    if(notAppliedPromoCode.error_code === 'MEMBER_ONLY'){
                                        OP.memberOnlyDialogue(dispatch, customer);
                                    }
                                }
                            }else{
                                dispatch(setOnePromotionPromoCode(promoCode, "error", "Unknown error"));
                            }
                        }else{
                            if(state.rootReducer.onePromotionPromoCode.status === "error"){
                                dispatch(setOnePromotionPromoCode(promoCode, "applied", "applied"));
                            }else{
                                if(appliedPromoCode.promotion_name !== promoCode){
                                    dispatch(setOnePromotionPromoCode(appliedPromoCode.promotion_name, "applied", "applied"));
                                }
                            }
                        }
                    }
                    resolve(productsInBasket);
                }, reject);
            }));
        });
    },
    validatePromoCode: (code, referenceNumber, customerID) => {
        return new Promise((resolve, reject) => {
            let dateTime = moment();
            dateTime.tz(OP.conf.timezone);
            let data = {
                clientName: OP.conf.clientName,
                referenceNumber,
                dateTime: dateTime.format("YYYY-MM-DD\THH:mm:ss"),
                code
            };
            if(customerID !== false){
                data.customerID = customerID;
            }
            fetchWithTimeout(process.env.REACT_APP_ONEPAY_URL + "/validateCoupon", {
                method: 'POST',
                headers: {
                    'Authorization': OP.conf.auth,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data),
                timeout: OP.conf.getQuoteTimeout
            }).then(response => {
                return response.json();
            }).then((response) => {
                console.log('OnePromotion api response', response);
                if(response.status.responseStatus === "ok"){
                    resolve(response.data);
                }else{
                    reject(response);
                }
            }).catch((response) => {
                console.log('OnePromotion api request failed', response);
                reject(response);
            });
        });
    },
    getQuote: (items, referenceNumber, promoCode, customer) => {
        return new Promise((resolve, reject) => {
            if(items.length === 0){
                resolve({items:[]});
                return;
            }
            let dateTime = moment();
            dateTime.tz(OP.conf.timezone);
            let data = {
                clientName: OP.conf.clientName,
                items,
                currency: OP.conf.currency,
                referenceNumber,
                dateTime: dateTime.format("YYYY-MM-DD\THH:mm:ss")
            };
            if(promoCode !== false){
                data.vouchers = [{
                    code: promoCode
                }];
            }
            if(customer !== false && customer.card_number !== ""){
                data.customer = {
                    id: customer.card_number
                }
                if(typeof customer?.rawData?.sub !== "undefined"){
                    data.customer.uuid = customer.rawData.sub
                }
            }
            fetchWithTimeout(process.env.REACT_APP_ONEPAY_URL + "/getQuote", {
                method: 'POST',
                headers: {
                    'Authorization': OP.conf.auth,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data),
                timeout: OP.conf.getQuoteTimeout
            }).then(response => {
                return response.json();
            }).then((response) => {
                console.log('OnePromotion api response', response);
                if(response.status.responseStatus === "ok"){
                    resolve(response.data);
                }else{
                    reject(response);
                }
            }).catch((response) => {
                console.log('OnePromotion api request failed', response);
                reject(response);
            });
        });
    },
    previousMixMatchProductsQuantity: 0,
    getPromotionableProducts: (productsInBasket, includeAll) => {
        return productsInBasket.reduce((acc, product) => {
            if(OP.productIsInExcludedCategory(product) || product.amount < 0){
                return acc;
            }
            if(includeAll || (product.hasMixMatchPromotion() && product.amount > 0 && product.hardDiscountable)){
                if(product.manualDiscountPercentage > 0 && (product?.onePromotion ?? false) === false){
                    return acc;
                }

                let price = product.originalPriceWithVAT || product.vatPrice;
                acc.items.push(new OP.Item(product.data.code, product.amount, price, product.rowTotal, product.lineNumber, "STANDARD"));
                acc.products.push(product);
            }else{
                if((product?.onePromotion ?? false) !== false){
                    acc.previouslyPromotionableProducts.push(product);
                }
            }
            return acc;
        }, {
            items: [],
            products: [],
            previouslyPromotionableProducts: []
        });
    },
    filterExcludedItems: (items, products, customer, productIDsWithMemberPrice) => {
        return items.filter(item => {
            let product = products.find(product => product.lineNumber === item.rowNumber);
            if(productIDsWithMemberPrice.indexOf(parseInt(product.data.productID)) !== -1){
                return false;
            }
            if(customer.isDecathlonEmployee() && product.data.seriesName === DECATHLON_EMPLOYEE_DISCOUNT_PRODUCT_SERIES){
                return false;
            }
            return true;
        });
    },
    onDocumentInit: () => {
        OP.previousMixMatchProductsQuantity = 0;
    },
    onPromotionCodeSet: (state, store) => {
        if(state.rootReducer.onePromotionPromoCode !== false && state.rootReducer.onePromotionPromoCode?.status !== "pending"){
            return;
        }

        let promoCode = state.rootReducer.onePromotionPromoCode.code;
        let addPromotion = (promoCodeAdded=false) => {
            OP.addPromotion(store, true, true).then((products) => {
                if(promoCodeAdded){
                    if(typeof products.find(el => typeof el.onePromotion !== "undefined") === "undefined"){
                        let currentState = store.getState();
                        if(!(currentState.rootReducer.onePromotionPromoCode.status === "error" && currentState.rootReducer.onePromotionPromoCode.message === "COUPON_NOT_APPLICABLE")){
                            store.dispatch(setOnePromotionPromoCode(promoCode, "error", "COUPON_NOT_APPLICABLE"));
                        }
                    }
                }
                store.dispatch({
                    type: APPLY_PROMOTIONS,
                    payload: {
                        triggerOP: false
                    }
                });
            }, (error) => {
                console.log("Failed to add a promotion", error);
            });
        }

        if(state.rootReducer.onePromotionPromoCode === false){
            addPromotion();
            return;
        }

        let customerID = state.rootReducer.customer?.rawData?.sub ?? false;

        OP.validatePromoCode(promoCode, state.rootReducer.warehouse.code, customerID).then((data) => {
            console.log("validatePromoCode success", data);
            let promoCodeStatus = data?.[promoCode] ?? "Coupon does not exist";
            if(promoCodeStatus === "OK"){
                store.dispatch(setOnePromotionPromoCode(promoCode, "applied", "applied"));
                addPromotion(true);
            }else{
                store.dispatch(setOnePromotionPromoCode(promoCode, "error", promoCodeStatus));
            }
        }, (response) => {
            console.log("validatePromoCode failed", response);
            let errorMessage = "Unknown error";
            if(response.status.statusCode === 400){
                errorMessage = "The coupon code is invalid";
            }else if(response.status.statusCode === 404){
                errorMessage = "Coupon does not exist";
            }
            store.dispatch(setOnePromotionPromoCode(promoCode, "error", errorMessage));
        });
    },
    onProductAdded: (state, store) => {
        const id = "onePromotion";
        if(state.rootReducer.productsInBasket.length === 0){
            OP.previousMixMatchProductsQuantity = 0;
        }
        if(typeof state.rootReducer.beforeApplyPromotionsEvents[id] === "undefined"){
            if(OP.conf === false){
                OP.setConf(state.rootReducer.erplyConf);
            }
            store.dispatch(addBeforeApplyPromotionsEvent((state, action) => {
                console.log("OP: addBeforeApplyPromotionsEvent", action);
                return new Promise((resolve, reject) => {
                    if(action?.payload?.triggerOP === false){
                        resolve();
                        return;
                    }
                    let retrigger =
                        action.type === SET_CUSTOMER ||
                        action.type === REMOVE_CUSTOMER ||
                        action.type === APPLY_PROMOTIONS;
                    OP.addPromotion(store, retrigger, false).then(resolve, (error) => {
                        console.log("Failed to add a promotion", error);
                        resolve();
                    });
                });
            }, id));
            setTimeout(() => {
                store.dispatch({
                    type: APPLY_PROMOTIONS
                });
            }, 1);
        }
    },
    productIsInExcludedCategory: (product) => {
        return OP.conf.excludedCategories.indexOf(product.data.seriesName) !== -1;
    },
    removeOnePromotionFromProduct: (product, preview, dispatch) => {
        if(product.onePromotion){
            product.resetManualDiscount();
            delete product.returnReasonID;
            delete product.returnReason;
            delete product.priceDerivationRuleID;
            delete product.onePromotion;
            if(preview === false){
                dispatch(updateProduct(product, true));
            }
        }
    },
    removeOnePromotionFromAllProducts: (productsInBasket, preview, dispatch) => {
        productsInBasket.forEach((product) => {
            OP.removeOnePromotionFromProduct(product, preview, dispatch);
        });
    },
    memberOnlyDialogue: (dispatch, customer) => {
        dispatch(showDialogue(
            "Member only coupon",
            "This offer is for members only. Please log in to your Decathlon account to use this code.",
            "Identify with my Decathlon account",
            () => {
                if(customer !== false && customer.default){
                    dispatch(setCustomer(false));
                }
                dispatch((changeMode(APP_MODE_BEFORE_PAYMENT)));
            },
            () => {
                dispatch(removeOnePromotionPromoCode());
            },
            "Remove coupon",
            false, undefined,undefined,true, undefined, "mediumButton blueButton", "mediumButton negativeActionButton"
        ));
    }
}

export default OP;
